export default __webpack_public_path__ + "static/media/installing-chat-widget.4a0a010a.svg";